<!--
 * @Descripttion:
 * @version:
 * @Author: lubaicen
 * @Date: 2020-09-10 14:20:04
 * @LastEditors: lubaicen
 * @LastEditTime: 2020-11-04 14:40:40
-->
<template>
  <ux-form
    ref="form"
    class="add-field-input x-flex-align"
    :data="formData"
    :rules="rules"
    :show-message="false"
    label-width="0px"
    :hideBtn="true"
  >
    <ux-form-item prop="name" :style="flexStyle(0)">
      <!-- <ux-select v-model="formData.name" :options="$opt.fixCodeList"></ux-select> -->
      <ux-input
        v-model="formData.name"
        size="small"
        :maxlength="50"
        :placeholder="$t('HT.pleaseInput')"
      ></ux-input>
    </ux-form-item>
    <ux-form-item prop="value" :style="flexStyle(1)">
      <ux-input
        v-model="formData.value"
        size="small"
        :maxlength="50"
        :placeholder="$t('HT.pleaseInput')"
      ></ux-input>
    </ux-form-item>
    <ux-form-item prop="position" :style="flexStyle(2)">
      <ux-select v-model="formData.position" :options="$opt.codePositionList"></ux-select>
    </ux-form-item>
    <ux-form-item prop="remark" :style="flexStyle(3)">
      <ux-input
        v-model="formData.remark"
        size="small"
        :maxlength="50"
        :placeholder="$t('HT.pleaseInput')"
      ></ux-input>
    </ux-form-item>
    <ux-form-item class="x-flex-center" :style="flexStyle(4)">
      <span class="x-table-blue-btn" @click="del">{{ $t('HT.remove') }}</span>
    </ux-form-item>
  </ux-form>
</template>

<script>
export default {
  props: {
    columns2: {
      // 表头数据
      type: Array
    },
    data: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      formData: this.data,
      rules: this.$rul.params()
    };
  },

  methods: {
    edit() {
      this.$emit('edit');
    },

    del() {
      this.$emit('del');
    },

    /**
     * 生成表单和表格对应的每个宽度布局
     * @param {Array} index 查询对象
     */
    flexStyle(index) {
      let width = this.columns2[index]['width'];
      if (width === undefined) {
        // 无设置width
        return { flex: 1 };
      }
      if (typeof width === 'number') {
        return { 'flex-basis': width + 'px' };
      }
      if (width.indexOf('px')) {
        // width添加单位px
        return { 'flex-basis': width };
      } else {
        return { 'flex-basis': width + 'px' };
      }
    }
  },

  watch: {
    data: {
      handler(val) {
        this.formData = val;
      },
      deep: true
    }
  }
};
</script>

<style lang="scss" scoped>
.add-field-input {
  width: 100%;
  height: 100%;

  .ux-form-item {
    padding: 0 10px;
    margin-bottom: 0 !important ;
  }
}
</style>
